import { Component } from "@angular/core";
import { AppSettings } from "../../app.settings";

@Component({
  selector: "unauthorized",
  template: `
  <br />
  <div>
      <h1 i18n>Authentication Error</h1>
      <div>
          {{authErrorDescription}} (Code: 401{{authError}})
      </div>
  </div>`
})
export class UnauthorizedComponent {
  authError = "";
  authErrorDescription = "";
  supplierPortalUrl = "";

  constructor(
    public appSettings: AppSettings
  ) { }

  ngOnInit() {
    this.supplierPortalUrl = this.appSettings?.SupplierPortalUrl;
  }
}
